// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shopcategory-banner{
    display: block;
    margin: 30px auto;
    width: 82%;
}
.shopcategory-indexSort{
    display: flex;
    margin: 0px 170px;
    justify-content: space-between;
    align-items: center;
}
.shopcategory-sort{
    padding: 10px 20px;
    border-radius: 40px;
    border: 1px solid #888;

}
.shopcategory-indexSort p span{
    font-weight: 600;
}
.shopcategory-products{
    margin: 20px 170px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    row-gap: 80px;

}
.shopcategory-loadmore{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 150px auto;
    width: 233px;
    height: 69px;
    border-radius: 75px;
    background: #ededed;
    color: #787878;
    font-size: 18px;
    font-weight: 500;
    
}
@media(max-width:1280px){
    .shopcategory-banner{
        margin: 20px auto;
        width: 90%;
    }
    .shopcategory-indexSort{
        width: 90%;
        margin: auto;
    }
    .shopcategory-sort{
        padding: 5px 10px;
        font-size: 12px;

    }
    .shopcategory-indexSort p{
        font-size: 12px;
    }
    .shopcategory-products{
        width: 90%;
        margin: 10px auto;
        row-gap: 40px;
    }
    .shopcategory-products .item{
        margin: auto;
    }
    .shopcategory-loadmore{
        margin: 100px auto;
        width: 200px;
        height: 60px;
        font-size: 16px;
    }
    @media(max-width: 800px){
        .shopcategory-banner{
            width: 95%;
        }
        .shopcategory-products{
            width: 95%;
        }
        .shopcategory-loadmore{
            margin: 60px auto;
            width: 150px;
            height: 40px;
            font-size: 13px;
        }
    }
    @media(max-width: 500px){
        .shopcategory-products{
            grid-template-columns: 1fr 1fr;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/CSS/ShopCategory.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;;AAE1B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sCAAsC;IACtC,aAAa;;AAEjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI;QACI,iBAAiB;QACjB,UAAU;IACd;IACA;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,iBAAiB;QACjB,eAAe;;IAEnB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,iBAAiB;QACjB,aAAa;IACjB;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI;YACI,UAAU;QACd;QACA;YACI,UAAU;QACd;QACA;YACI,iBAAiB;YACjB,YAAY;YACZ,YAAY;YACZ,eAAe;QACnB;IACJ;IACA;QACI;YACI,8BAA8B;QAClC;IACJ;AACJ","sourcesContent":[".shopcategory-banner{\n    display: block;\n    margin: 30px auto;\n    width: 82%;\n}\n.shopcategory-indexSort{\n    display: flex;\n    margin: 0px 170px;\n    justify-content: space-between;\n    align-items: center;\n}\n.shopcategory-sort{\n    padding: 10px 20px;\n    border-radius: 40px;\n    border: 1px solid #888;\n\n}\n.shopcategory-indexSort p span{\n    font-weight: 600;\n}\n.shopcategory-products{\n    margin: 20px 170px;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    row-gap: 80px;\n\n}\n.shopcategory-loadmore{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 150px auto;\n    width: 233px;\n    height: 69px;\n    border-radius: 75px;\n    background: #ededed;\n    color: #787878;\n    font-size: 18px;\n    font-weight: 500;\n    \n}\n@media(max-width:1280px){\n    .shopcategory-banner{\n        margin: 20px auto;\n        width: 90%;\n    }\n    .shopcategory-indexSort{\n        width: 90%;\n        margin: auto;\n    }\n    .shopcategory-sort{\n        padding: 5px 10px;\n        font-size: 12px;\n\n    }\n    .shopcategory-indexSort p{\n        font-size: 12px;\n    }\n    .shopcategory-products{\n        width: 90%;\n        margin: 10px auto;\n        row-gap: 40px;\n    }\n    .shopcategory-products .item{\n        margin: auto;\n    }\n    .shopcategory-loadmore{\n        margin: 100px auto;\n        width: 200px;\n        height: 60px;\n        font-size: 16px;\n    }\n    @media(max-width: 800px){\n        .shopcategory-banner{\n            width: 95%;\n        }\n        .shopcategory-products{\n            width: 95%;\n        }\n        .shopcategory-loadmore{\n            margin: 60px auto;\n            width: 150px;\n            height: 40px;\n            font-size: 13px;\n        }\n    }\n    @media(max-width: 500px){\n        .shopcategory-products{\n            grid-template-columns: 1fr 1fr;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
